// Set up select2 on select elements
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

$(() => {
  $('select').select2({
    language: 'en',
    width: '100%'
  });
});
